import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Refund & Cancellation Policy</h1>
      <p className="text-gray-500 text-sm mb-8">Last updated: June 2025</p>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 space-y-8 text-gray-700 text-sm leading-relaxed">

        <section>
          <p className="text-base">
            At <strong>KLMKart (PK Agri)</strong>, customer satisfaction is our priority. Please read our
            Refund & Cancellation Policy carefully to understand your options in case of issues with your order.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Order Cancellation</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Before Shipment:</strong> Orders can be cancelled before they are dispatched for shipping.
              To cancel, contact us immediately at{' '}
              <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a>{' '}
              or call <a href="tel:+917995004136 " className="text-blue-600 hover:underline">+91 7995004136 </a>.
            </li>
            <li>
              <strong>After Shipment:</strong> Once an order has been dispatched, it cannot be cancelled.
              You may initiate a return after receiving the product if it qualifies under our return policy.
            </li>
            <li>
              <strong>Refund on Cancellation:</strong> If your cancellation is approved, a full refund will
              be processed to the original payment method within 7–10 business days.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Returns</h2>
          <p className="mb-2">Returns are accepted under the following conditions:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>The product received is <strong>damaged</strong> or <strong>defective</strong>.</li>
            <li>The return is reported within <strong>3 days</strong> of delivery.</li>
            <li>The product is unused and in its original packaging.</li>
            <li>Photographic or video evidence of the damage/defect is provided at the time of reporting.</li>
          </ul>
          <p className="mt-3">
            <strong>Non-Returnable Items:</strong> Products that have been used, altered, or damaged due to
            misuse, or items clearly marked as non-returnable at the time of purchase, are not eligible for return.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">3. How to Initiate a Return</h2>
         <ol className="list-decimal pl-6 space-y-2">
        <li>If you receive a damaged, defective, or incorrect product, you may raise a refund request within 3 business days from the date of delivery.</li>
        <li>Contact our support team with your order number and clear photographs or video evidence of the issue.</li>
        <li>Our team will review and verify your request within 2 business days of submission.</li>
        <li>Once approved, we will arrange a pickup or request you to ship the product back to us.</li>
        </ol>
          <p className="mt-3">
            Contact:{' '}
            <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a>{' '}
            | <a href="tel:+917995004136 " className="text-blue-600 hover:underline">+91 7995004136 </a>
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Refund Process</h2>
            <ul className="list-disc pl-6 space-y-2">
            <li>Once your refund request is received, our team will review and verify the reported issue promptly.</li>
            <li>After successful verification, the refund will be credited within 2 to 4 business days.</li>
            <li>Refunds will be processed to the original payment method used at the time of purchase.</li>
            <li>You will be notified via email or SMS once your refund has been successfully processed.</li>
            </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Exchange Policy</h2>
          <p>
            We currently do not offer direct product exchanges. If you wish to replace a defective or damaged
            item, please initiate a return and place a new order for the desired product.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Disputes</h2>
          <p>
            If you are not satisfied with our resolution, you may escalate the issue by emailing us at{' '}
            <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a>{' '}
            with the subject line <strong>"Dispute – [Order ID]"</strong>. We are committed to resolving all
            disputes fairly and promptly.
          </p>
        </section>

        <section className="border-t border-gray-100 pt-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Contact Us</h2>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p><strong>Company Name:</strong> KLMKart </p>
            <p><strong>Email:</strong> <a href="mailto:klmkartsales@gmail.com" className="text-blue-600 hover:underline">klmkartsales@gmail.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+917995004136 " className="text-blue-600 hover:underline">+91 7995004136 </a></p>
            <p><strong>Address:</strong> H.NO-8-5-136/12/P,T, S.R. COMPLEX, DURGA NAGAR X ROAD, MAILARDEVPALLY, RAJENDRANAGAR, Rangareddy</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default RefundPolicy;